import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  albiMainFieldsCols,
  codiceEsitiFields,
  cols,
  colsCSV,
  esecutivitaFields,
  esitoFields,
  profiloCommittenteFieldsCols,
  provvedimentiFieldsCols,
  registroAccessiFieldsCols,
} from "./pubblicazioni-list-constants";
import { LazyLoadEvent, MessageService } from "primeng/api";
import {
  AdditionalDataDefinition,
  FilterDefinition,
  FiltersAndSorts,
  FILTER_TYPES,
  SortDefinition,
  SORT_MODES,
  PagingConf,
  NextSDREntityProvider,
} from "@bds/next-sdr";
import { ColonnaBds, CsvExtractor } from "@bds/common-tools";
import { Subscription } from "rxjs";
import { buildLazyEventFiltersAndSorts } from "@bds/primeng-plugin";
import { Albo, SpecificheTabellaAlbi, TipiTabellaAlbi } from "../../albi-constants";
import { ExtendedPubblicazione } from "./extended-pubblicazione";
import { PubblicazioniListService } from "./pubblicazioni-list.service";
import { ViewChild } from "@angular/core";
import { ColumnFilter, Table } from "primeng/table";
import { Pubblicazione, TipologiaAlbo } from "src/app/entities/Pubblicazione";
import { ViewChildren } from "@angular/core";
import { QueryList } from "@angular/core";
import { DatePipe } from "@angular/common";
import { AutoComplete } from "primeng/autocomplete";
import { PubblicazioniAlboAttiveListService } from "./pubblicazioni-albo-attive-list.service";
import { PubblicazioniAlboTutteListService } from "./pubblicazioni-albo-tutte-list.service";
import { coerceStringArray } from "@angular/cdk/coercion";
import { DatePicker } from "primeng/datepicker";
import { PubblicazioniRegistroAccessiAttiveListService } from "./pubblicazioni-registro-accessi-attive-list.service";
import { PubblicazioniCommittenteAttiveListService } from "./pubblicazioni-committente-attive-list.service";
import { ProvvedimentiAttiviListService } from "./provvedimenti-attivi-list.service";

@Component({
  selector: "app-pubblicazioni-list",
  templateUrl: "./pubblicazioni-list.component.html",
  styleUrls: ["./pubblicazioni-list.component.scss"],
  standalone: false,
})
export class PubblicazioniListComponent implements OnInit {
  public rowsNumber: number = 40;
  public pubblicazioni: ExtendedPubblicazione[] = Array.from({ length: this.rowsNumber });
  public cols: ColonnaBds[];
  public initialSortField: string;
  public totalRecords: number;
  private resetPubblicazioniArrayLenght: boolean = true;
  public loading: boolean = false;
  private loadPubblicazioniListSubscription: Subscription;
  public selectedColumns: ColonnaBds[];
  public dataMinima: Date = new Date("2000-01-01");
  public dataMassima: Date = new Date("2030-12-31");
  public filtriPuliti: boolean = true;
  public projectionToUse: string;
  public selectedPubblicazione: Pubblicazione;
  public registroFiltrabili: any = [{ value: "", nome: "TUTTI" }];
  public selectedRegistroFiltrabili: any = this.registroFiltrabili[0];
  public registroFiltrabili2: any = [];
  public selectedRegistroFiltrabili2: any = { value: null, nome: "" };
  public esitoFiltrabili: ValueAndNomeObj[] = esitoFields;
  public esecutivitaFiltrabili: ValueAndNomeObj[] = esecutivitaFields;
  public selectCodiceEsitiItems = codiceEsitiFields;
  public selectedCodiceEsiti = this.selectCodiceEsitiItems[0];
  public exportCsvInProgress: boolean = false;
  public showEsitiCaption: boolean = false;
  public exportCsvName: string;
  private serviceToUse: NextSDREntityProvider;

  private storedLazyLoadEvent: LazyLoadEvent;
  private lastFilterState: any = {};
  private pageConf: PagingConf = { mode: "LIMIT_OFFSET_NO_COUNT", conf: { limit: 0, offset: 0 } };

  @Output() showRightPanel = new EventEmitter<{ showPanel: boolean; rowSelected: Pubblicazione }>();
  @Output() showSpinning = new EventEmitter<{ showSpinning: boolean }>();

  //@Input() azienda: string;
  @Input() albo: Albo;

  @ViewChildren(ColumnFilter) filterColumns: QueryList<ColumnFilter>;
  @ViewChild("dt") public dataTable: Table;
  @ViewChild("dt", { read: ElementRef }) public dataTableElement: ElementRef;
  @ViewChild("autocompleteEsecutivita") public autocompleteEsecutivita: AutoComplete;

  constructor(
    private pubblicazioniListService: PubblicazioniListService,
    private pubblicazioniAlboAttiveListService: PubblicazioniAlboAttiveListService,
    private pubblicazioniAlboTutteListService: PubblicazioniAlboTutteListService,
    private pubblicazioniRegistroAccessiAttiveListService: PubblicazioniRegistroAccessiAttiveListService,
    private pubblicazioniCommittenteAttiveListService: PubblicazioniCommittenteAttiveListService,
    private provvedimentiAttiviListService: ProvvedimentiAttiviListService,
    private messageService: MessageService,
    private datepipe: DatePipe,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadConfigurationAndSetItUp();
    this.getRegistri();
  }

  /**
   * Metodo che popola il menù a tendina di ricerca "Scegli registro" della colonna Dati Registro
   */
  getRegistri(): void {
    let valoriRegistro: any = [];
    if (this.albo.tipo === "PROFILO_COMMITTENTE") {
      valoriRegistro.push({ value: "", nome: "TUTTI" });
    }

    this.pubblicazioniListService
      .getRegistri(this.albo)
      .subscribe((registri) =>
        registri.map((registro) => valoriRegistro.push({ value: [registro.codice], nome: [registro.descrizione] }))
      );
    switch (this.albo.tipo) {
      case "ALBO":
      case "ALBO_TUTTE": {
        this.registroFiltrabili2 = valoriRegistro;
        break;
      }
      case "PROFILO_COMMITTENTE": {
        this.registroFiltrabili = valoriRegistro;
        break;
      }
    }
  }

  //When selecting a row pubb.detail component is called with row params
  public onRowSelected(show: boolean, rowContent: any) {
    this.showRightPanel.emit({
      showPanel: show,
      rowSelected: rowContent as Pubblicazione,
    });
  }

  private fixTableTransform() {
    if (this.dataTableElement) {
      // Trova il tbody nell'elemento della tabella
      const tbody = this.dataTableElement.nativeElement.querySelector("tbody");
      if (tbody) {
        // Rimuovi il transform
        tbody.style.transform = "";
        console.log("Rimosso il transform dal tbody");
      }
    }
  }

  /**
   * Metodo chiamato dalla tabella.
   * Calcola il pageconf, salva i filtri e chiama la loadData
   * @param event
   */
  public onLazyLoad(event: LazyLoadEvent): void {
    if (event.rows === 0) {
      return;
    }

    console.log(`---------------------------------------------------------------`);
    console.log(`Chiedo ${event.rows} righe con offset di ${event.first}`);

    if (event.first % this.rowsNumber !== 0) {
      console.log(`Offset non corretto, non cairco i dati`);
      return;
    }

    if (event.first === 0 && event.rows === this.rowsNumber) {
      this.resetPubblicazioniArrayLenght = true;
      this.fixTableTransform();
    }

    this.storedLazyLoadEvent = event;

    const isFilterEvent = this.hasFiltersChanged(event.filters, this.lastFilterState);
    this.lastFilterState = structuredClone(event.filters);

    if (isFilterEvent) {
      this.resetPubblicazioniArrayLenght = true;
    }

    this.loadData();
  }

  private hasFiltersChanged(currentFilters: any, lastFilterState: any): boolean {
    // Se non ci sono filtri precedenti allora è il primo giro e non ho "nuovi" filtri
    if (!lastFilterState) {
      return false;
    }

    // Confronta i filtri
    const lastKeys = Object.keys(lastFilterState);
    const currentKeys = Object.keys(currentFilters);

    // Numero diverso di filtri
    if (lastKeys.length !== currentKeys.length) {
      return true;
    }

    // Confronta ogni filtro
    for (const key of currentKeys) {
      const lastFilter = lastFilterState[key];
      const currentFilter = currentFilters[key];

      if (lastFilter && currentFilter) {
        // Se il filtro è cambiato
        if (JSON.stringify(lastFilter) !== JSON.stringify(currentFilter)) {
          return true;
        }
        // if (
        //   !deepEqual(
        //     lastFilter.value,
        //     currentFilter.value
        //   )
        //   /* lastFilter.value !== currentFilter.value || lastFilter.matchMode !== currentFilter.matchMode */
        // ) {
        //   return true;
        // }
      }
    }

    return false;
  }

  /**
   * Builda i filtri della tabella. Aggiunge eventuali altri filtri.
   * Carica i docs per la lista.
   * @param event
   */
  private loadData(): void {
    // console.log(this.storedLazyLoadEvent)
    this.loading = true;
    this.pageConf.conf = {
      limit: this.storedLazyLoadEvent.rows,
      offset: this.storedLazyLoadEvent.first,
    };
    if (this.loadPubblicazioniListSubscription) {
      this.loadPubblicazioniListSubscription.unsubscribe();
      this.loadPubblicazioniListSubscription = null;
    }
    const filtersAndSorts: FiltersAndSorts = this.buildCustomFilterAndSort();

    if (this.resetPubblicazioniArrayLenght) {
      this.resetPubblicazioniArrayLenght = false;
      if (this.pubblicazioni.length !== this.rowsNumber) {
        this.pubblicazioni = Array.from({ length: this.rowsNumber });
      }
    }

    if (this.albo.tipo === TipiTabellaAlbi.ALBO) {
      this.loadPubblicazioniListSubscription = this.pubblicazioniAlboAttiveListService
        .getData(
          this.projectionToUse,
          filtersAndSorts,
          buildLazyEventFiltersAndSorts(this.storedLazyLoadEvent, this.cols, this.datepipe),
          this.pageConf
        )
        .subscribe({
          next: (data: any) => {
            this.loadDataAfterSubscribe(data);
          },
          error: () => {
            this.messageService.add({
              severity: "warn",
              key: "pubblicazioniListToast",
              summary: "Attenzione",
              detail: `Si è verificato un errore nel caricamento. Riprovare più tardi.`,
            });
          },
        });
    } else if (this.albo.tipo === TipiTabellaAlbi.ALBO_TUTTE) {
      this.loadPubblicazioniListSubscription = this.pubblicazioniAlboTutteListService
        .getData(
          this.projectionToUse,
          filtersAndSorts,
          buildLazyEventFiltersAndSorts(this.storedLazyLoadEvent, this.cols, this.datepipe),
          this.pageConf
        )
        .subscribe({
          next: (data: any) => {
            this.loadDataAfterSubscribe(data);
          },
          error: () => {
            this.messageService.add({
              severity: "warn",
              key: "pubblicazioniListToast",
              summary: "Attenzione",
              detail: `Si è verificato un errore nel caricamento. Riprovare più tardi.`,
            });
          },
        });
    } else if (this.albo.tipo === TipiTabellaAlbi.REGISTRO_ACCESSI) {
      this.loadPubblicazioniListSubscription = this.pubblicazioniRegistroAccessiAttiveListService
        .getData(
          this.projectionToUse,
          filtersAndSorts,
          buildLazyEventFiltersAndSorts(this.storedLazyLoadEvent, this.cols, this.datepipe),
          this.pageConf
        )
        .subscribe({
          next: (data: any) => {
            this.loadDataAfterSubscribe(data);
          },
          error: () => {
            this.messageService.add({
              severity: "warn",
              key: "pubblicazioniListToast",
              summary: "Attenzione",
              detail: `Si è verificato un errore nel caricamento. Riprovare più tardi.`,
            });
          },
        });
    } else if (this.albo.tipo === TipiTabellaAlbi.PROFILO_COMMITTENTE) {
      this.loadPubblicazioniListSubscription = this.pubblicazioniCommittenteAttiveListService
        .getData(
          this.projectionToUse,
          filtersAndSorts,
          buildLazyEventFiltersAndSorts(this.storedLazyLoadEvent, this.cols, this.datepipe),
          this.pageConf
        )
        .subscribe({
          next: (data: any) => {
            this.loadDataAfterSubscribe(data);
          },
          error: () => {
            this.messageService.add({
              severity: "warn",
              key: "pubblicazioniListToast",
              summary: "Attenzione",
              detail: `Si è verificato un errore nel caricamento. Riprovare più tardi.`,
            });
          },
        });
    } else if (this.albo.tipo === TipiTabellaAlbi.PROVVEDIMENTI) {
      this.loadPubblicazioniListSubscription = this.provvedimentiAttiviListService
        .getData(
          this.projectionToUse,
          filtersAndSorts,
          buildLazyEventFiltersAndSorts(this.storedLazyLoadEvent, this.cols, this.datepipe),
          this.pageConf
        )
        .subscribe({
          next: (data: any) => {
            this.loadDataAfterSubscribe(data);
          },
          error: () => {
            this.messageService.add({
              severity: "warn",
              key: "pubblicazioniListToast",
              summary: "Attenzione",
              detail: `Si è verificato un errore nel caricamento. Riprovare più tardi.`,
            });
          },
        });
    } else {
      this.loadPubblicazioniListSubscription = this.pubblicazioniListService
        .getData(
          this.projectionToUse,
          filtersAndSorts,
          buildLazyEventFiltersAndSorts(this.storedLazyLoadEvent, this.cols, this.datepipe),
          this.pageConf
        )
        .subscribe({
          next: (data: any) => {
            this.loadDataAfterSubscribe(data);
            this.loading = false;
          },
          error: () => {
            this.messageService.add({
              severity: "warn",
              key: "pubblicazioniListToast",
              summary: "Attenzione",
              detail: `Si è verificato un errore nel caricamento. Riprovare più tardi.`,
            });
          },
        });
    }
  }

  private loadDataAfterSubscribe(data: any) {
    //console.log(data);

    // this.totalRecords = data.page.totalElements;
    // let results = data.results;

    // if (this.resetPubblicazioniArrayLenght) {
    //   /* Ho bisogno di far capire alla tabella quanto l'array  è virtualmente grande
    //   in questo modo la scrollbar sarà sufficientemente lunga per scrollare fino all'ultimo elemento
    //   ps:a quanto pare la proprietà totalRecords non è sufficiente. */
    //   this.resetPubblicazioniArrayLenght = false;
    //   this.dataTable.resetScrollTop();
    //   this.pubblicazioni = Array.from({ length: this.totalRecords });
    // }
    // if (this.albo.tipo === TipiTabellaAlbi.ALBO) {
    //   results = this.convertPubblicazioneAlboAttivaIntoPubblicazione(results);
    // }
    // if (this.pageConf.conf.offset === 0 && data.page.totalElements < this.pageConf.conf.limit) {
    //   /* Questo meccanismo serve per cancellare i risultati di troppo della tranche precedente.
    //   Se entro qui probabilmente ho fatto una ricerca */
    //   Array.prototype.splice.apply(this.pubblicazioni, [0, this.pubblicazioni.length, ...this.setCustomProperties(results)]);
    // } else {
    //   Array.prototype.splice.apply(this.pubblicazioni, [
    //     this.storedLazyLoadEvent.first,
    //     this.storedLazyLoadEvent.rows,
    //     ...this.setCustomProperties(results),
    //   ]);
    // }
    // this.pubblicazioni = [...this.pubblicazioni]; // trigger change detection
    //console.log(this.pubblicazioni)
    this.loading = false;
    const pubblicazioniCaricate = this.setCustomProperties(data.results);
    const existAnotherElementNext: boolean = data.page.totalPages > 1;
    if (this.storedLazyLoadEvent.first + this.rowsNumber === this.pubblicazioni.length) {
      console.log(`Sto riempendo l'intero array di pubblicazioni, forse dovrò espanderlo`);
      // Se la lunghezza dei dati caricati è uguale a quanto richiesto, allora ho caricato tutti i dati richiesti
      if (pubblicazioniCaricate.length === this.storedLazyLoadEvent.rows) {
        if (existAnotherElementNext) {
          // Devo espandere l'array di virtual cars di altri this.rowsNumber posti perchè non ho ancora caricato tutti i dati
          console.log(`In questo momento l'array è lungo ${this.pubblicazioni.length}, gli do altri this.rowsNumber posti`);
          Array.prototype.splice.apply(this.pubblicazioni, [
            ...[this.storedLazyLoadEvent.first, this.storedLazyLoadEvent.rows],
            ...[...pubblicazioniCaricate, ...Array.from({ length: this.rowsNumber })],
          ]);
        } else {
          console.log(`In questo momento l'array è lungo ${this.pubblicazioni.length}, ha raggiunto la fine`);
          Array.prototype.splice.apply(this.pubblicazioni, [
            ...[this.storedLazyLoadEvent.first, this.storedLazyLoadEvent.rows],
            ...[...pubblicazioniCaricate],
          ]);
        }
      } else {
        // Ho trovato meno righe di quante cercate, ho raggiuto il fondo della lista
        console.log(
          `In questo momento l'array è lungo ${this.pubblicazioni.length}, ma sono arrivato in fondo devo togliergli ${
            this.rowsNumber - pubblicazioniCaricate.length
          } posti`
        );
        Array.prototype.splice.apply(this.pubblicazioni, [
          ...[this.storedLazyLoadEvent.first, this.rowsNumber],
          ...pubblicazioniCaricate,
        ]);
        console.log(`Adesso l'array è lungo ${pubblicazioniCaricate.length}`);
      }
    } else {
      console.log(`Caricamento semplice`);
      Array.prototype.splice.apply(this.pubblicazioni, [
        this.storedLazyLoadEvent.first,
        this.storedLazyLoadEvent.rows,
        ...pubblicazioniCaricate,
      ]);
    }

    this.dataTable.scroller.setSize();
    this.dataTable.scroller.setSpacerSize();

    //trigger change detection
    this.storedLazyLoadEvent.forceUpdate();
  }

  /**
   * Converto da PubblicazioneAlboAttiva a Pubblicazione
   */
  private convertPubblicazioneAlboAttivaIntoPubblicazione(pubblicazioniAlboAttivaList: any[]): Pubblicazione[] {
    const pubList: Pubblicazione[] = [];
    pubblicazioniAlboAttivaList.forEach((pubAA) => {
      const pub: Pubblicazione = new Pubblicazione();
      pub.allegatiList = pubAA.allegatiList;
      pub.annoPubblicazione = pubAA.annoPubblicazione;
      pub.articolazione = pubAA.articolazione;
      pub.dataInserimento = pubAA.dataInserimento;
      pub.dataUltimaModifica = pubAA.dataUltimaModifica;
      pub.id = pubAA.id;
      pub.idApplicazione = pubAA.fk_idApplicazione;
      pub.idAzienda = pubAA.fk_idAzienda;
      pub.idProvvedimento = null;
      pub.idRegistroAccessi = null;
      pub.numeroPubblicazione = pubAA.numeroPubblicazione;
      pub.oggetto = pubAA.oggetto;
      pub.periodoPubblicazioneList = pubAA.periodoPubblicazioneList;
      pub.pubblicazioneCommittente = null;
      pub.sottoTipologiaAlbo = null;
      pub.tipiDocumentiList = pubAA.tipiDocumentiList;
      pub.tipologiaAlbo = TipologiaAlbo.ALBO;
      pub.version = pubAA.version;
      pubList.push(pub);
    });
    return pubList;
  }

  /**
   * Converto da PubblicazioneAlboAttiva a Pubblicazione
   */
  private convertPubblicazioneRegistroAccessiAttivaIntoPubblicazione(
    pubblicazioniRegistroAccessiAttivaList: any[]
  ): Pubblicazione[] {
    const pubList: Pubblicazione[] = [];
    pubblicazioniRegistroAccessiAttivaList.forEach((pubAA) => {
      const pub: Pubblicazione = new Pubblicazione();
      pub.annoPubblicazione = pubAA.annoPubblicazione;
      pub.articolazione = pubAA.articolazione;
      pub.dataInserimento = pubAA.dataInserimento;
      pub.dataUltimaModifica = pubAA.dataUltimaModifica;
      pub.id = pubAA.id;
      pub.idApplicazione = pubAA.fk_idApplicazione;
      pub.idAzienda = pubAA.fk_idAzienda;
      pub.idProvvedimento = null;
      pub.idRegistroAccessi = null;
      pub.numeroPubblicazione = pubAA.numeroPubblicazione;
      pub.oggetto = pubAA.oggetto;
      pub.periodoPubblicazioneList = pubAA.periodoPubblicazioneList;
      pub.pubblicazioneCommittente = null;
      pub.sottoTipologiaAlbo = null;
      pub.tipiDocumentiList = pubAA.tipiDocumentiList;
      pub.tipologiaAlbo = TipologiaAlbo.REGISTRO_ACCESSI;
      pub.version = pubAA.version;
      pub.idRegistroAccessi = pubAA.idRegistroAccessi;
      pub.registroAccessi = pubAA.registroAccessi;
      pubList.push(pub);
    });
    return pubList;
  }

  /**
   * Parso Pubblicazione[] facendolo diventare ExtendedPubblicazione[] con le
   * proprietà utili alla visualizzazione popolate
   * @param docsList
   * @returns
   */
  private setCustomProperties(pubblicazioniList: Pubblicazione[]): ExtendedPubblicazione[] {
    const extendedPubblicazione: ExtendedPubblicazione[] = pubblicazioniList as ExtendedPubblicazione[];
    extendedPubblicazione.forEach((pubblicazione: ExtendedPubblicazione) => {
      Object.setPrototypeOf(pubblicazione, ExtendedPubblicazione.prototype);
      pubblicazione.datiPubblicazioneVisualizzazione = null;
      pubblicazione.datiRegistroVisualizzazione = null;
      pubblicazione.esecutivitaVisualizzazione = null;
      pubblicazione.dataEsecutivitaVisualizzazione = null;
      pubblicazione.dataFinePubblicazioneVisualizzazione = null;
      pubblicazione.dataInizioPubblicazioneVisualizzazione = null;
      pubblicazione.dataAdozioneVisualizzazione = null;
      pubblicazione.dataRegistrazioneVisualizzazione = null;
      pubblicazione.registroVisualizzazione = null;
      pubblicazione.annoRegistroVisualizzazione = null;
      pubblicazione.numeroRegistroVisualizzazione = null;
      pubblicazione.attoDiIniziativaVisualizzazione = null;
      pubblicazione.dataIniziativaVisualizzazione = null;
      pubblicazione.dataChiusuraVisualizzazione = null;
      pubblicazione.provvedimentoFinaleVisualizzazione = null;
      pubblicazione.linkBDNCPVisualizzazione = null;
      pubblicazione.linkItercentERVisualizzazione = null;
    });
    return extendedPubblicazione;
  }

  /**
   * Metodo che intercetta la ricerca globale. E' solo un passa carte.
   * Di fatto poi scatta l'onLazyLoad
   * @param event
   * @param matchMode
   */
  public applyFilterGlobal(event: Event, matchMode: string) {
    const stringa: string = (event.target as HTMLInputElement).value;
    if (!!!stringa || stringa === "") {
      this.resetSort();
    }
    this.dataTable.filterGlobal(stringa, matchMode);
  }

  /**
   * Metodo che reimposta il sort di default. Cioè al campo definito in initialSortField
   */
  public resetSort(): void {
    this.dataTable.sortField = this.initialSortField;
    this.dataTable.sortOrder = this.dataTable.defaultSortOrder;
    this.dataTable.sortSingle();
  }

  /**
   * Metodo che toglie il sort dalle colonne della tabella.
   * In particolare è usata dagli input dei campi che quando usati ordinano per ranking
   */
  public removeSort(): void {
    this.dataTable.sortField = null;
    this.dataTable.sortOrder = null;
    this.dataTable.tableService.onSort(null);
  }

  /**
   * Questa funzione gestisce l'utilizzo dei pulsanti custom dei calendari
   * @param calendar
   * @param command
   * @param event
   */
  public handleCalendarButtonEvent(calendar: DatePicker, command: string, event: Event, filterCallback: (value: Date[]) => {}) {
    if (command === "doFilter" || command === "onClickOutside") {
      // pulsante OK
      calendar.hideOverlay();
    } else if (command === "setToday") {
      // pulsante OGGI
      calendar.writeValue([new Date(), null]);
      calendar.hideOverlay();
    } else if (command === "clear") {
      // pulsante SVUOTA
      calendar.onClearButtonClick(event);
    }
    if (calendar.inputId === "calendar") {
      calendar.clearButtonStyleClass;
    }
    filterCallback(calendar.value);
  }

  /**
   * Funzione che si occupa di fare il clear di tutti i filtri della tabella.
   * In particolare quelli delle autocomplete che sono "separati" dal semplice
   * table.reset() vengono fatti a patto che quell'autocomplete esista.
   * @param table
   */
  public clear(): void {
    //this.inputGobalFilter.nativeElement.value = "";
    if (this.autocompleteEsecutivita) this.autocompleteEsecutivita.writeValue(null);

    this.myDatatableReset();
  }

  /**
   * this.dataTable.reset(); fa un po' troppa roba e non riesco a gestirlo.
   * Quindi il reset me lo faccio io a mano.
   */
  public myDatatableReset() {
    for (const key in this.dataTable.filters) {
      (this.dataTable.filters as any)[key]["value"] = null;
    }
    this.dataTable.filteredValue = null;
    this.dataTable.first = 0;
    this.resetSort();
  }

  /**
   * Questa funzione si occupa di caricare la configurazione delle colonne
   * in base al tipo di albo richiesto tramite url
   * Sulla base di questo vengono poi settate le colonne visualizzate
   *
   */
  private loadConfigurationAndSetItUp(): void {
    this.nomeOfCsvFile();
    var protoCols = cols;
    let colsToUse;
    switch (this.albo.tipo) {
      case TipiTabellaAlbi.ALBO:
      case TipiTabellaAlbi.ALBO_TUTTE:
        colsToUse = albiMainFieldsCols;
        this.initialSortField = "dataDal";
        this.projectionToUse =
          this.albo.tipo === TipiTabellaAlbi.ALBO_TUTTE
            ? "PubblicazioneAlboTutteWithAllegatiListAndPeriodoPubblicazioneListAndTipiDocumentiList"
            : "PubblicazioneAlboAttivaWithAllegatiListAndPeriodoPubblicazioneListAndTipiDocumentiList";

        protoCols = cols.map((x) => {
          // con questo map tolgo il la parte periodoPubblicazioneList da filtro e ordinamento
          // cosi che la riceca possa essere eseguita correttamente su pubblicazioniAlboAttive
          const stringToReplace = "periodoPubblicazioneList.";
          if (x.filterField.startsWith(stringToReplace)) {
            x.filterField = x.filterField.replace(stringToReplace, "");
          }
          if (typeof x.sortField === "string") {
            if (x.sortField.startsWith(stringToReplace)) {
              x.sortField = x.sortField.replace(stringToReplace, "");
            }
          } else if (typeof x.sortField === "object") {
            x.sortField.forEach((x) => {
              if (x.startsWith(stringToReplace)) {
                x = x.replace(stringToReplace, "");
              }
            });
          }
          return x;
        });
        break;
      case TipiTabellaAlbi.PROVVEDIMENTI:
        colsToUse = provvedimentiFieldsCols;
        this.initialSortField = "dataInserimento";
        this.projectionToUse = "ProvvedimentoAttivoWithAllegatiListAndProvvedimentoAndTipiDocumentiList";
        break;
      case TipiTabellaAlbi.PROFILO_COMMITTENTE:
        this.initialSortField = null;
        this.projectionToUse =
          "PubblicazioneCommittenteAttivaWithAllegatiListAndPeriodoPubblicazioneListAndPubblicazioneCommittenteAndTipiDocumentiList";
        if (this.albo.specifica === SpecificheTabellaAlbi.LEGGE190) {
          const excludedFields: string[] = ["cig", "cigAzienda", "linkIntercent", "linkBdncp"];
          colsToUse = profiloCommittenteFieldsCols.filter((field) => !excludedFields.includes(field));
        } else {
          colsToUse = profiloCommittenteFieldsCols;
        }
        if (this.albo.specifica == SpecificheTabellaAlbi.ESITI) {
          this.showEsitiCaption = true;
        }

        break;
      case TipiTabellaAlbi.REGISTRO_ACCESSI:
        colsToUse = registroAccessiFieldsCols;
        //todo change in the next RM-s
        this.initialSortField = null;
        this.projectionToUse =
          "PubblicazioneRegistroAccessiAttivaWithAllegatiListAndPeriodoPubblicazioneListAndRegistroAccessiAndTipiDocumentiList";
        protoCols = cols.map((x) => {
          // con questo map tolgo il la parte periodoPubblicazioneList da filtro e ordinamento
          // cosi che la riceca possa essere eseguita correttamente
          const stringToReplace = "periodoPubblicazioneList.";
          if (x.filterField.startsWith(stringToReplace)) {
            x.filterField = x.filterField.replace(stringToReplace, "");
          }
          if (typeof x.sortField === "string") {
            if (x.sortField.startsWith(stringToReplace)) {
              x.sortField = x.sortField.replace(stringToReplace, "");
            }
          } else if (typeof x.sortField === "object") {
            x.sortField.forEach((x) => {
              if (x.startsWith(stringToReplace)) {
                x = x.replace(stringToReplace, "");
              }
            });
          }
          return x;
        });
        break;
    }

    this.cols = [];
    colsToUse.forEach((x) => {
      this.cols.push(protoCols.find((y) => y.field == x));
    });
    // console.log('le colonne sono ', this.cols);
  }

  /**
   * Questo metodo costruisce filtri e sorting non provenienti dalla p-table
   * In particolare si occupa di impostare i giusti filtri a seconda
   * del tab selezionato (docsListMode)
   * @returns
   */
  private buildCustomFilterAndSort(): FiltersAndSorts {
    const filterAndSort = new FiltersAndSorts();
    if (
      this.albo.tipo !== TipiTabellaAlbi.ALBO &&
      this.albo.tipo !== TipiTabellaAlbi.ALBO_TUTTE &&
      this.albo.tipo !== TipiTabellaAlbi.REGISTRO_ACCESSI
    ) {
      filterAndSort.addFilter(new FilterDefinition("tipologiaAlbo", FILTER_TYPES.not_string.equals, this.albo.tipo));
    }
    filterAndSort.addFilter(new FilterDefinition("idAzienda.id", FILTER_TYPES.string.equals, this.albo.azienda));
    if (this.albo.tipo == TipiTabellaAlbi.PROFILO_COMMITTENTE || this.albo.tipo == TipiTabellaAlbi.PROVVEDIMENTI) {
      filterAndSort.addFilter(new FilterDefinition("sottoTipologiaAlbo", FILTER_TYPES.not_string.equals, this.albo.specifica));
      //filterAndSort.addSort(new SortDefinition("dataAl", SORT_MODES.desc));
    }
    if (this.albo.specifica == SpecificheTabellaAlbi.ESITI) {
      this.selectedCodiceEsiti.value.forEach((element) => {
        filterAndSort.addFilter(
          new FilterDefinition("pubblicazioneCommittente.codiceProfiloCommittente", FILTER_TYPES.string.contains, element)
        );
      });
    }
    // if (this.albo.tipo === TipiTabellaAlbi.ALBO) {
    //   filterAndSort.addAdditionalData(new AdditionalDataDefinition('OperationRequested', "FilterAlbo"));
    // }
    //this is only for Registro Accessi if the user since tipo Documenti is an array and for filtering are nedded 2 conditions same time
    //this case is managed bu backend interceptor
    //todo maybe is better to create tscol in db
    if (this.albo.tipo === TipiTabellaAlbi.REGISTRO_ACCESSI) {
      if (this.storedLazyLoadEvent.filters.provvedimentoFinale.value) {
        filterAndSort.addAdditionalData(
          new AdditionalDataDefinition(
            "tipoRelazioneFinale",
            this.storedLazyLoadEvent.filters.provvedimentoFinale.value.toString()
          )
        );
      }
      if (this.storedLazyLoadEvent.filters.attoDiIniziativa.value) {
        filterAndSort.addAdditionalData(
          new AdditionalDataDefinition(
            "tipoRelazioneIniziale",
            this.storedLazyLoadEvent.filters.attoDiIniziativa.value.toString()
          )
        );
      }
      if (this.storedLazyLoadEvent.filters.dataIniziativa.value) {
        filterAndSort.addAdditionalData(
          new AdditionalDataDefinition(
            "tipoRelazioneInizialeDate0",
            this.datepipe.transform(this.storedLazyLoadEvent.filters.dataIniziativa.value[0], "yyyy-MM-dd'T'HH:mm:ss Z")
          )
        );
        if (this.storedLazyLoadEvent.filters.dataIniziativa.value[1]) {
          filterAndSort.addAdditionalData(
            new AdditionalDataDefinition(
              "tipoRelazioneInizialeDate1",
              this.datepipe.transform(this.storedLazyLoadEvent.filters.dataIniziativa.value[1], "yyyy-MM-dd'T'HH:mm:ss Z")
            )
          );
        }
      }
      if (this.storedLazyLoadEvent.filters.dataChiusura.value) {
        filterAndSort.addAdditionalData(
          new AdditionalDataDefinition(
            "tipoRelazioneFinaleDate0",
            this.datepipe.transform(this.storedLazyLoadEvent.filters.dataChiusura.value[0], "yyyy-MM-dd'T'HH:mm:ss Z")
          )
        );
        if (this.storedLazyLoadEvent.filters.dataChiusura.value[1]) {
          filterAndSort.addAdditionalData(
            new AdditionalDataDefinition(
              "tipoRelazioneFinaleDate1",
              this.datepipe.transform(this.storedLazyLoadEvent.filters.dataChiusura.value[1], "yyyy-MM-dd'T'HH:mm:ss Z")
            )
          );
        }
      }
    }

    /**
     * Aggiungo un sort per id alla tabella, in modo che, se viene selezionata
     * una colonna con valori uguali, a ogni caricamento le righe siano sempre
     * ordinate allo stesso modo. Unica eccezzione è quando si filtra per oggetto,
     * in questo caso il sort non viene inserito per dare priorità all'ordinamento
     * per Ranking presente in quella colonna.
     */
    if (!this.storedLazyLoadEvent.filters.oggetto.value) {
      filterAndSort.addSort(new SortDefinition("id", SORT_MODES.desc));
    }

    return filterAndSort;
  }

  /**
   * Oltre desottoscrivermi dalle singole sottoscrizioni, mi
   * desottoscrivo anche dalla specifica loadDocsListSubscription
   * Che appositamente è separata in quanto viene spesso desottoscritta
   * e risottroscritta.
   */
  public ngOnDestroy(): void {
    if (this.loadPubblicazioniListSubscription) {
      this.loadPubblicazioniListSubscription.unsubscribe();
    }
  }

  //method when detail pubblicazione is closed from X
  clearSelectedRow(): void {
    this.selectedPubblicazione = null;
  }

  //method to download the csv file
  public exportCSV2() {
    this.showSpinning.emit({ showSpinning: true });
    this.exportCsvInProgress = true;
    const tableTemp = {} as Table;

    Object.assign(tableTemp, this.dataTable);
    tableTemp.csvSeparator = ";";
    const pageConfNoLimit: PagingConf = {
      conf: {
        page: 0,
        size: 999999,
      },
      mode: "PAGE_NO_COUNT",
    };
    const filtersAndSorts: FiltersAndSorts = this.buildCustomFilterAndSort();
    if (this.albo.tipo === TipiTabellaAlbi.ALBO_TUTTE) {
      this.serviceToUse = this.pubblicazioniAlboTutteListService;
    } else if (this.albo.tipo === TipiTabellaAlbi.ALBO) {
      this.serviceToUse = this.pubblicazioniAlboAttiveListService;
    } else if (this.albo.tipo === TipiTabellaAlbi.REGISTRO_ACCESSI) {
      this.serviceToUse = this.pubblicazioniRegistroAccessiAttiveListService;
    } else if (this.albo.tipo === TipiTabellaAlbi.PROFILO_COMMITTENTE) {
      this.serviceToUse = this.pubblicazioniCommittenteAttiveListService;
    } else if (this.albo.tipo === TipiTabellaAlbi.PROVVEDIMENTI) {
      this.serviceToUse = this.provvedimentiAttiviListService;
    } else {
      this.serviceToUse = this.pubblicazioniListService;
    }
    this.serviceToUse
      .getData(
        this.projectionToUse,
        filtersAndSorts,
        buildLazyEventFiltersAndSorts(this.storedLazyLoadEvent, this.cols, this.datepipe),
        pageConfNoLimit
      )
      .subscribe(
        (res) => {
          if (res && res.results) {
            if (this.albo.tipo === TipiTabellaAlbi.ALBO || this.albo.tipo === TipiTabellaAlbi.ALBO_TUTTE) {
              res.results = this.convertPubblicazioneAlboAttivaIntoPubblicazione(res.results);
            }
            if (this.albo.tipo === TipiTabellaAlbi.REGISTRO_ACCESSI) {
              res.results = this.convertPubblicazioneRegistroAccessiAttivaIntoPubblicazione(res.results);
            }
            tableTemp.value = this.setCustomProperties(res.results);
            console.log(tableTemp.value);

            tableTemp.columns = colsCSV.filter((c) => {
              return this.cols.some((e) => {
                return e.field === c.fieldId;
              });
            });
            console.log(tableTemp.columns);
            const extractor = new CsvExtractor();
            extractor.exportCsv(tableTemp);
          }
          this.showSpinning.emit({ showSpinning: false });
          this.exportCsvInProgress = false;
        },
        (err) => {
          this.showSpinning.emit({ showSpinning: false });
          this.exportCsvInProgress = false;
        }
      );
  }

  //method to get the name of csv doc which is downloaded
  public nomeOfCsvFile() {
    if (this.albo.specifica) {
      this.exportCsvName = this.albo.tipo.replace(/\n/g, " ") + " " + this.albo.specifica;
    } else this.exportCsvName = this.albo.tipo.replace(/\n/g, " ");
  }

  //method to change bettwen different tabs of profilo-committente esiti
  public onSelectButtonItemSelection(event: any): void {
    this.selectedCodiceEsiti = event.option;
    this.loadData();
  }

  trackByFn(index: any, item: any) {
    if (item) {
      return item.id;
    }
    //return index;
  }
}

export interface ValueAndNomeObj {
  value: string;
  nome: string;
}
